import { useNavigate } from '@tanstack/react-router';
import { MY_SUBSCRIPTIONS_CATEGORY_ID } from '../constants';
import { useTargetEnterpriseIdContext } from '../context';

export const useNavigateToSubscriptions = () => {
    const targetEnterpriseId = useTargetEnterpriseIdContext();
    const navigate = useNavigate();

    const navigateToSubscriptions = () => {
        void navigate({
            to: '/$currentEnterpriseId/EnterpriseIntegration/Marketplace',
            params: { currentEnterpriseId: targetEnterpriseId },
            search: {
                OwnerId: targetEnterpriseId,
                CategoryId: MY_SUBSCRIPTIONS_CATEGORY_ID,
            },
        });
    };

    return { navigateToSubscriptions };
};
